import React from "react";
import {useTable, useSortBy} from "react-table";
import {useSelector} from "react-redux";
import ReactPaginate from "react-paginate";
import {DefaultArrow, DownArrow, UpArrow} from "../../../Resident/sortArrows";
import moment from "moment/moment";

const FormRequestsTab = () => {
  const state = useSelector((state) => {
    return {
      organizationName: state.organization.name,
      affiliateMemberId: state.affiliateMember.id,
    }
  });

  const [formRequests, setFormRequests] = React.useState([]);
  const [currentPage, setCurrentPage] = React.useState(1);
  const [totalPages, setTotalPages] = React.useState(1);

  const fetchFormRequests = () => {
    const {organizationName, affiliateMemberId} = state;
    $.ajax({
      url: `/organizations/${organizationName}/affiliate_members/${affiliateMemberId}/form_requests.json?${$.param(createRansackQuery())}`,
      success: (response) => {
        setFormRequests(response.form_requests);
        setTotalPages(response.total_pages);
        setCurrentPage(response.current_page);
      }
    })
  }

  const createRansackQuery = () => {
    return {
      page: currentPage
    }
  }

  React.useEffect(() => {
    fetchFormRequests();
  }, [currentPage]);

  const columns = React.useMemo(() => [
    {
      Header: "Name",
      id: "name",
      disableSortBy: true,
      accessor: (row) => row.name,
      Cell: ({cell: {row: {original}}}) => (
        <span>{original.title}</span>
      )
    },
    {
      Header: "Date Request Sent",
      id: "request_sent_at",
      disableSortBy: true,
      accessor: (row) => row.request_sent_at,
      Cell: ({cell: {row: {original}}}) => (
       <span>{original.request_sent_at}</span>
      )
    },
    {
      Header: "Request Sent By",
      id: "author_name",
      accessor: (row) => row.author_name,
      disableSortBy: true,
      Cell: ({cell: {row: {original}}}) => (
        <span>{original.author_name}</span>
      )
    },
  ], [formRequests])

  const {getTableProps, headerGroups, rows, prepareRow} = useTable(
    {
      columns,
      data: formRequests,
      initialState: {},
      manualSorting: true
    },
    useSortBy
  );

  return (
    <>
      <table {...getTableProps()} className="table table-responsive">
        <thead>
        {headerGroups.map(headerGroup => (
          <tr {...headerGroup.getHeaderGroupProps()}>
            {headerGroup.headers.map(column => (
              <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                {column.render('Header')}
                {
                  !column.disableSortBy && (
                    <span>
                      {column.isSorted ? (column.isSortedDesc ? <DownArrow /> : <UpArrow />) : <DefaultArrow />}
                    </span>
                  )
                }
              </th>
            ))}
            <th />
          </tr>
        ))}
        </thead>
        <tbody>
        {rows.map(
          (row, i) =>
            prepareRow(row) || (
              <tr {...row.getRowProps()}>
                {row.cells.map(cell => {
                  return <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                })}
              </tr>
            )
        )}
        </tbody>
      </table>
      {
        totalPages > 1 && <ReactPaginate
          containerClassName="pagination"
          pageClassName="page-item"
          pageLinkClassName="page-link"
          activeClassName="active"
          pageCount={totalPages}
          onPageChange={(page) =>
            setCurrentPage(page.selected + 1)
          }
        />
      }
    </>
  )
}

export default FormRequestsTab;
